// eslint-disable-next-line aloft/no-sui-chakra
import { ChakraProps } from '@aloft/toolkit-sui/chakra';

import { HEADER_HEIGHT_IN_PX } from './constants.ts';
import { isLastPinned } from './isLastPinned.ts';
import { isPinned } from './isPinned.ts';

const BORDER_HEIGHT_PX = 3;

export const getPinnedCellStyles = (
  shouldPinFirstRow: boolean | number,
  rowIndex: number,
  isColumnPinned = false,
): ChakraProps => {
  if (!isPinned(shouldPinFirstRow, rowIndex)) return {};

  return {
    position: 'sticky',
    top: `${HEADER_HEIGHT_IN_PX * (rowIndex + 1) + BORDER_HEIGHT_PX * rowIndex}px`,
    // Non-column-pinned cells in a pinned row must sit below horizontally-pinned
    // column cells (zIndex: 1) so they don't obscure them when scrolling horizontally.
    zIndex: isColumnPinned ? 3 : 0,
    ...(isLastPinned(shouldPinFirstRow, rowIndex) && { borderBottomWidth: '2px' }),
  };
};
